/* eslint-disable react-refresh/only-export-components */
import type { ReactElement } from 'react';
import type { SeverityType } from '@kirin/api-client/contracts/shared/severity';
import { SeverityBadge } from '@/components/policylist/components/SeverityBadge';

export {
  CategoryBadge,
  isRecentlyDetected,
} from '@/components/shared/shadow-ai';

export function RiskBadge({ level }: { level: SeverityType }): ReactElement {
  return <SeverityBadge riskLevel={level} showIcon />;
}

export function formatBytes(bytes: number): string {
  if (bytes === 0) return '0 B';
  const k = 1024;
  const sizes = ['B', 'KB', 'MB', 'GB', 'TB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(1))} ${sizes[i]}`;
}
